import { Box, Typography } from "@mui/material";

/**
 * Pílula de status unificada da área do cliente: fundo tênue (bg) + ponto e
 * texto na cor do status (color). Consistente entre Pedidos e Orçamentos.
 * Se `bg` não for informado, cai numa pílula neutra com borda.
 *
 * @param {string} color cor do ponto e do texto
 * @param {string} bg    cor de fundo tênue (opcional)
 * @param {string} label texto do status
 */
export default function StatusChip({ color, bg, label }) {
    const tinted = Boolean(bg);
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.6,
                px: 0.9,
                py: 0.3,
                borderRadius: '4px',
                whiteSpace: 'nowrap',
                color: color,
                bgcolor: tinted ? bg : 'transparent',
                border: tinted ? 'none' : '1px solid',
                borderColor: 'divider',
            }}
        >
            <Box
                component="span"
                sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: color, flexShrink: 0 }}
            />
            <Typography component="span" variant="body2" sx={{ fontWeight: 600, lineHeight: 1, color: 'inherit' }}>
                {label}
            </Typography>
        </Box>
    );
}
